import { useEffect, useRef, useState, useCallback } from "react";
import { buildQueryString } from "../../helpers/buildQueryString";
import { useData } from "../DataContext/DataContextt";
import { buildOptions } from "../../helpers/EntityHelper";

export const useSearch = (
  allOptions,
  apiSearch,

  { displayNameFields = [], extraKeys = [] },
) => {
  const [options, setOptions] = useState(allOptions);
  const [searching, setSearching] = useState(false);
  const { language } = useData();

  useEffect(() => {
    setOptions(allOptions);
  }, [allOptions]);

  const search = useCallback(
    async (query) => {
      if (!query) {
        setOptions(allOptions);
        return;
      }

      // Local search first
      const localResults = allOptions.filter((o) =>
        o.displayName.toLowerCase().includes(query.toLowerCase()),
      );

      if (localResults.length > 0 || !apiSearch) {
        setOptions(localResults);
        return;
      }

      // API search
      setSearching(true);
      try {
        const searchString = buildQueryString({
          searchOn: "id",
          language,
          page: 0,
          rowsPerPage: 50,
          searchTerm: `${query}*`,
        });

        const response = await apiSearch(searchString);
        const responseOptions = buildOptions(
          response?.results,
          "id",
          displayNameFields,
          extraKeys,
        );

        setOptions(responseOptions);
      } finally {
        setSearching(false);
      }
    },
    [allOptions, apiSearch],
  );

  return { options, search, searching };
};
